export default __webpack_public_path__ + "static/media/S2F_Logo_EN.19463d24.svg";